// import React from "react";

// function Pricing() {
//   return (
//     <>
//       <div className="pricing-style-one-area default-padding bg-gray">
//         <div className="container">
//           <div className="text-center pb-20">
//             <h4 className="sub-title">Pricing Plan</h4>
//             <h2
//               className="title split-text-right split-text-in-right split-lines"
//               data-anim="left"
//             >
//               Flexible Engagement Models
//             </h2>
//           </div>
//           <div className="row">
//             <div className="col-xl-6">
//               <ul className="pricing-types fade-up-anim">
//                 <li>
//                   <div className="icon">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/icon/12.png"
//                       alt="Image Not FOund"
//                     />
//                   </div>
//                   <div className="info">
//                     <h4>Fixed Cost Projects</h4>
//                     <p>
//                       Ideal for clearly defined projects with fixed scope,
//                       timeline, and predictable development cost.
//                     </p>
//                   </div>
//                 </li>
//                 <li>
//                   <div className="icon">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/icon/14.png"
//                       alt="Image Not FOund"
//                     />
//                   </div>
//                   <div className="info">
//                     <h4>Dedicated Development Teams</h4>
//                     <p>
//                       Hire a full-time team dedicated to your project with
//                       flexible control and continuous development.
//                     </p>
//                   </div>
//                 </li>
//               </ul>
//             </div>
//             <div className="col-xl-6 pl-80 pl-md-15 pl-xs-15">
//               <ul className="pricing-types fade-up-anim">
//                 <li>
//                   <div className="icon">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/icon/13.png"
//                       alt="Image Not FOund"
//                     />
//                   </div>
//                   <div className="info">
//                     <h4>Hourly / Monthly Retainers</h4>
//                     <p>
//                       Flexible engagement where clients pay based on hourly work
//                       or monthly resource allocation.
//                     </p>
//                   </div>
//                 </li>
//                 <li>
//                   <div className="icon">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/icon/13.png"
//                       alt="Image Not FOund"
//                     />
//                   </div>
//                   <div className="info">
//                     <h4>Enterprise Long-Term Contracts</h4>
//                     <p>
//                       Strategic long-term partnerships for continuous
//                       development, upgrades, and enterprise support.
//                     </p>
//                   </div>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Pricing;

import React from "react";
import { FaFileContract, FaUsers, FaClock, FaBuilding } from "react-icons/fa";

const pricingData = [
  {
    icon: FaFileContract,
    title: "Fixed Cost Projects",
    desc: "Ideal for clearly defined projects with fixed scope, timeline, and predictable development cost.",
  },
  {
    icon: FaUsers,
    title: "Dedicated Development Teams",
    desc: "Hire a full-time team dedicated to your project with flexible control and continuous development.",
  },
  {
    icon: FaClock,
    title: "Hourly / Monthly Retainers",
    desc: "Flexible engagement where clients pay based on hourly work or monthly resource allocation.",
  },
  {
    icon: FaBuilding,
    title: "Enterprise Long-Term Contracts",
    desc: "Strategic long-term partnerships for continuous development, upgrades, and enterprise support.",
  },
];

function Pricing() {
  return (
    <div className="pricing-modern">
      <div className="container text-center">
        <h4 className="sub-title">Pricing Plan</h4>
        <h2 className="title">Flexible Engagement Models</h2>

        <div className="timeline">
          {pricingData.map((item, i) => {
            const Icon = item.icon;
            return (
              <div className="timeline-item" key={i}>
                <div className="timeline-icon">
                  <Icon />
                </div>

                <div className="timeline-content">
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Pricing;
